(function(){
  if(window.__ixUiBound)return;
  window.__ixUiBound=true;
  var FAVORITES_KEY='indexes_favorites_v1';
  var ADD_TIMEOUT_MS=12000;
  var addStates=new WeakMap();
  var cartCountGeneration=0;
  var globalFeedbackTimer=0;

  function ensureGlobalFeedback(){
    var notice=document.querySelector('[data-ix-global-feedback]');
    if(notice)return notice;
    notice=document.createElement('div');
    notice.className='ix-global-feedback';
    notice.setAttribute('data-ix-global-feedback','');
    notice.setAttribute('role','status');
    notice.setAttribute('aria-live','polite');
    notice.setAttribute('aria-atomic','true');
    notice.hidden=true;
    document.body.appendChild(notice);
    return notice;
  }

  function showGlobalFeedback(message,state){
    if(!document.body)return;
    var notice=ensureGlobalFeedback();
    window.clearTimeout(globalFeedbackTimer);
    notice.hidden=true;
    notice.textContent='';
    notice.className='ix-global-feedback is-'+(state||'info');
    notice.textContent=message;
    notice.hidden=false;
    globalFeedbackTimer=window.setTimeout(function(){notice.hidden=true},7000);
  }

  // Keep the direct WhatsApp enquiry and discount display on the selected variant.
  function syncProduct(root){
    if(!root)return;
    var select=root.querySelector('[data-ix-variant-select]');
    var option=select&&select.selectedOptions[0];
    var quantityInput=root.querySelector('[data-ix-qty-input]');
    var quantity=Number(quantityInput&&quantityInput.value);
    var link=root.querySelector('.ix-product-whatsapp');
    if(!link)return;
    if(!Number.isSafeInteger(quantity)||quantity<1){
      link.removeAttribute('href');
      link.setAttribute('aria-disabled','true');
      document.querySelectorAll('[data-ix-product-contact]').forEach(function(contact){
        contact.removeAttribute('href');
        contact.setAttribute('aria-disabled','true');
      });
      return;
    }
    var variantInput=root.querySelector('[data-ix-variant-id]');
    if(!variantInput)return;
    var variantId=variantInput.value;
    var title=option?option.dataset.title:root.dataset.ixVariant;
    var rawPrice=Number(option?option.dataset.rawPrice:root.dataset.ixRawPrice);
    var price=Number.isFinite(rawPrice)&&rawPrice>0
      ?String(rawPrice/100)
      :(option?option.dataset.price:root.dataset.ixPrice);
    var url=new URL(root.dataset.ixUrl);
    url.search='';
    url.hash='';
    url.searchParams.set('variant',variantId);
    // Decode the human-readable path only; retain URL delimiters and the selected variant.
    var readableUrl=url.origin+decodeURI(url.pathname)+url.search;
    var d=root.dataset;
    var message=[
      d.ixGreeting,
      d.ixTitle,
      d.ixVariantLabel+': '+title,
      d.ixQuantityLabel+': '+quantity,
      d.ixPriceLabel+': '+price,
      d.ixCurrencyLabel+': '+d.productCurrency,
      d.ixLinkLabel+':',
      readableUrl,
      '',
      d.ixConfirmation
    ].join('\n');
    var href='https://wa.me/967771370740?text='+encodeURIComponent(message);
    link.href=href;
    document.querySelectorAll('[data-ix-product-contact]').forEach(function(contact){
      contact.href=href;
      contact.removeAttribute('aria-disabled');
      contact.dataset.variantId=variantId;
    });
    link.removeAttribute('aria-disabled');
    if(option){
      var amount=Number(option.dataset.rawPrice);
      var compare=Number(option.dataset.compare);
      var validSale=Number.isFinite(amount)&&amount>0&&Number.isFinite(compare)&&compare>amount;
      var percent=validSale?Math.round((compare-amount)*100/compare):0;
      var oldPrice=root.querySelector('[data-ix-compare-price]');
      if(oldPrice){
        oldPrice.hidden=!validSale;
        oldPrice.textContent=validSale?option.dataset.compareFormatted:'';
      }
      root.querySelectorAll('[data-ix-sale-label],[data-ix-sale-badge]').forEach(function(badge){
        badge.hidden=!validSale||percent===0||badge.dataset.hasNew==='true';
        badge.textContent=d.ixSaleTemplate.replace('__PERCENT__',String(percent));
      });
    }
  }

  function readFavorites(){
    try{
      var value=JSON.parse(localStorage.getItem(FAVORITES_KEY)||'[]');
      if(!Array.isArray(value))return {ok:false,items:[]};
      return {
        ok:true,
        items:value.filter(function(item){return typeof item==='string'&&item.length>0})
      };
    }catch(error){
      return {ok:false,items:[]};
    }
  }

  function writeFavorites(items){
    try{
      localStorage.setItem(FAVORITES_KEY,JSON.stringify(items));
      return true;
    }catch(error){
      return false;
    }
  }

  function favoriteTitle(button){
    var product=button.closest('[data-ix-product]');
    if(product&&product.dataset.ixTitle)return product.dataset.ixTitle.trim();
    var card=button.closest('.ix-product-card');
    var cardTitle=card&&card.querySelector('.ix-product-card__title');
    if(cardTitle&&cardTitle.textContent.trim())return cardTitle.textContent.trim();
    var wishlist=button.closest('.ix-wishlist-card__body');
    var wishlistTitle=wishlist&&wishlist.querySelector('a');
    return wishlistTitle?wishlistTitle.textContent.trim():'';
  }

  function favoriteLabel(button,active){
    var title=favoriteTitle(button);
    if(active)return title?'إزالة '+title+' من المفضلة':'إزالة من المفضلة';
    return title?'إضافة '+title+' إلى المفضلة':'إضافة إلى المفضلة';
  }

  function refreshFavorites(committedItems){
    var result=Array.isArray(committedItems)?{ok:true,items:committedItems}:readFavorites();
    if(!result.ok)return false;
    document.querySelectorAll('[data-ix-favorite]').forEach(function(button){
      var active=result.items.indexOf(button.getAttribute('data-ix-favorite'))>-1;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',active?'true':'false');
      button.setAttribute('aria-label',favoriteLabel(button,active));
    });
    return true;
  }

  function addEndpoint(form){
    try{
      var url=new URL(form.action,location.href);
      if(!/\/cart\/add(?:\.js)?$/.test(url.pathname))return null;
      url.pathname=url.pathname.replace(/\/cart\/add(?:\.js)?$/,'/cart/add.js');
      return url;
    }catch(error){
      return null;
    }
  }

  function cartEndpoint(addUrl){
    var url=new URL(addUrl.href);
    url.pathname=url.pathname.replace(/\/cart\/add\.js$/,'/cart.js');
    url.search='';
    return url;
  }

  function cartReviewUrl(addUrl){
    var url=new URL(addUrl.href);
    url.pathname=url.pathname.replace(/\/cart\/add\.js$/,'/cart');
    url.search='';
    return url.href;
  }

  function feedbackHost(form){
    return form.closest('.ix-product-card__actions')||form;
  }

  function ensureAddFeedback(form){
    var state=addStates.get(form);
    if(state&&state.feedback)return state.feedback;
    var feedback=document.createElement('div');
    feedback.className='ix-action-feedback';
    feedback.setAttribute('data-ix-add-feedback','');
    feedback.setAttribute('role','status');
    feedback.setAttribute('aria-live','polite');
    feedback.setAttribute('aria-atomic','true');
    feedback.hidden=true;
    feedbackHost(form).insertAdjacentElement('afterend',feedback);
    if(state)state.feedback=feedback;
    return feedback;
  }

  function showAddFeedback(form,stateName,message,reviewUrl){
    var feedback=ensureAddFeedback(form);
    feedback.hidden=true;
    feedback.replaceChildren();
    feedback.className='ix-action-feedback is-'+stateName+(stateName==='pending'?' visually-hidden':'');
    var text=document.createElement('span');
    text.textContent=message;
    feedback.appendChild(text);
    if(reviewUrl){
      var link=document.createElement('a');
      link.href=reviewUrl;
      link.textContent='عرض السلة';
      feedback.appendChild(link);
    }
    feedback.hidden=false;
  }

  function getAddState(form,submitter){
    var state=addStates.get(form);
    if(!state){
      state={generation:0,pending:false,uncertain:false,controller:null,timeout:0,feedback:null,button:null,variantSelect:null};
      addStates.set(form,state);
    }
    state.button=submitter||form.querySelector('button[type="submit"],input[type="submit"]');
    return state;
  }

  function beginAdd(form,state,disableControls){
    window.clearTimeout(state.visualTimer);
    if(state.button)delete state.button.dataset.ixAddVisual;
    state.generation++;
    state.pending=true;
    state.uncertain=false;
    form.dataset.ixAddState='pending';
    form.setAttribute('aria-busy','true');
    if(state.button){
      state.originalHtml=state.button.innerHTML;
      state.originalValue=state.button.value;
      state.originalDisabled=state.button.disabled;
      state.originalAriaLabel=state.button.getAttribute('aria-label');
      if(disableControls)state.button.disabled=true;
      state.button.setAttribute('aria-busy','true');
      // Keep the original control and artwork stable; CSS shows progress in place.
      state.button.setAttribute('aria-label','جارٍ إضافة المنتج إلى السلة…');
    }
    var productRoot=form.closest('[data-ix-product]');
    state.variantSelect=productRoot&&productRoot.querySelector('[data-ix-variant-select]');
    if(state.variantSelect&&disableControls){
      state.originalVariantDisabled=state.variantSelect.disabled;
      state.variantSelect.disabled=true;
    }else{
      state.variantSelect=null;
    }
    showAddFeedback(form,'pending','جارٍ إضافة المنتج إلى السلة…');
    return state.generation;
  }

  function restoreAdd(form,state){
    window.clearTimeout(state.timeout);
    state.timeout=0;
    state.pending=false;
    state.uncertain=false;
    state.controller=null;
    delete form.dataset.ixAddState;
    form.removeAttribute('aria-busy');
    if(state.button){
      if(state.button.tagName==='INPUT')state.button.value=state.originalValue||'';
      else if(typeof state.originalHtml==='string')state.button.innerHTML=state.originalHtml;
      state.button.disabled=Boolean(state.originalDisabled);
      state.button.removeAttribute('aria-busy');
      if(state.originalAriaLabel===null)state.button.removeAttribute('aria-label');
      else state.button.setAttribute('aria-label',state.originalAriaLabel);
    }
    if(state.variantSelect){
      state.variantSelect.disabled=Boolean(state.originalVariantDisabled);
      state.variantSelect=null;
    }
  }

  function markAddUncertain(form,state,reviewUrl){
    window.clearTimeout(state.timeout);
    state.timeout=0;
    state.pending=false;
    state.uncertain=true;
    state.controller=null;
    form.dataset.ixAddState='uncertain';
    form.removeAttribute('aria-busy');
    if(state.button){
      state.button.disabled=true;
      state.button.removeAttribute('aria-busy');
      if(state.button.tagName==='INPUT')state.button.value='راجع السلة';
      else if(!state.button.classList.contains('ix-card-action--image'))state.button.textContent='راجع السلة';
      state.button.setAttribute('aria-label','راجع السلة قبل محاولة الإضافة مرة أخرى');
    }
    if(state.variantSelect){
      state.variantSelect.disabled=Boolean(state.originalVariantDisabled);
      state.variantSelect=null;
    }
    showAddFeedback(
      form,
      'warning',
      'لم نتمكن من تأكيد نتيجة الإضافة. راجع السلة قبل المحاولة مرة أخرى لتجنب إضافة المنتج مرتين.',
      reviewUrl
    );
  }

  function refreshCartCount(addUrl){
    var generation=++cartCountGeneration;
    fetch(cartEndpoint(addUrl).href,{credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(function(response){
        if(!response.ok)throw new Error('cart');
        return response.json();
      })
      .then(function(cart){
        if(generation!==cartCountGeneration)return;
        var count=Number(cart.item_count);
        if(!Number.isFinite(count))return;
        var badges=Array.from(document.querySelectorAll('[data-ix-cart-count]'));
        document.querySelectorAll('.ix-shell__cart,.ix-mobile-nav a').forEach(function(link){
          var matches=false;
          try{matches=/\/cart$/.test(new URL(link.href,location.href).pathname)}catch(error){}
          if(!matches||link.querySelector('[data-ix-cart-count]'))return;
          var badge=document.createElement('b');
          badge.setAttribute('data-ix-cart-count','');
          var badgeHost=link.querySelector('.ix-mobile-nav__icon-wrap')||link;
          badgeHost.appendChild(badge);
          badges.push(badge);
        });
        badges.forEach(function(badge){
          badge.textContent=String(count);
          badge.hidden=count===0;
        });
      })
      .catch(function(){});
  }

  function productCanSubmit(form){
    if(!form.matches('.ix-product-actions'))return true;
    var root=form.closest('[data-ix-product]');
    if(!root)return false;
    var select=root.querySelector('[data-ix-variant-select]');
    var option=select&&select.selectedOptions[0];
    var amount=Number(option?option.dataset.rawPrice:root.dataset.ixRawPrice);
    return Number.isFinite(amount)&&amount>0;
  }

  function enhanceAddSubmit(event,form){
    var state=getAddState(form,event.submitter);
    if(state.pending||state.uncertain||form.dataset.ixAddState){
      event.preventDefault();
      return;
    }
    if(!productCanSubmit(form)){
      event.preventDefault();
      return;
    }
    var endpoint=addEndpoint(form);
    var enhanced=endpoint&&window.fetch&&window.FormData&&window.AbortController&&window.Promise;
    var generation=beginAdd(form,state,Boolean(enhanced));
    if(!enhanced)return;
    event.preventDefault();
    state.controller=new AbortController();
    state.timeout=window.setTimeout(function(){
      if(state.generation!==generation||!state.pending)return;
      try{state.controller.abort()}catch(error){}
    },ADD_TIMEOUT_MS);
    fetch(endpoint.href,{
      method:'POST',
      body:new FormData(form),
      credentials:'same-origin',
      headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},
      signal:state.controller.signal
    })
      .then(function(response){
        if(response.ok){
          return response.json().catch(function(){throw {kind:'uncertain'}});
        }
        if(response.status>=400&&response.status<500&&![408,425,429].includes(response.status))throw {kind:'definite'};
        throw {kind:'uncertain'};
      })
      .then(function(){
        if(state.generation!==generation)return;
        restoreAdd(form,state);
        if(state.button){
          state.button.dataset.ixAddVisual='success';
          state.visualTimer=window.setTimeout(function(){if(!state.pending&&state.button?.dataset.ixAddVisual==='success')delete state.button.dataset.ixAddVisual},1600);
        }
        showAddFeedback(form,'success','تمت الإضافة إلى السلة.',cartReviewUrl(endpoint));
        refreshCartCount(endpoint);
        document.dispatchEvent(new CustomEvent('indexes:cart-added'));
      })
      .catch(function(error){
        if(state.generation!==generation)return;
        if(error&&error.kind==='definite'){
          restoreAdd(form,state);
          showAddFeedback(form,'error','تعذرت الإضافة. تحقق من الخيار والكمية ثم أعد المحاولة.');
          return;
        }
        markAddUncertain(form,state,cartReviewUrl(endpoint));
      });
  }

  function cartFormDirty(form){
    return Boolean(form.querySelector('ix-cart-services[data-dirty="true"]')) || Array.from(form.querySelectorAll('input[name="updates[]"],textarea[name="note"]')).some(function(input){
      return input.value!==input.defaultValue;
    });
  }

  function syncCartForm(form){
    if(!form)return;
    var dirty=cartFormDirty(form);
    var note=form.querySelector('[data-ix-cart-update-note]');
    var continueLink=form.querySelector('.ix-cart-whatsapp');
    form.dataset.ixCartDirty=dirty?'true':'false';
    if(continueLink){
      continueLink.classList.toggle('is-disabled',dirty);
      if(dirty)continueLink.setAttribute('aria-disabled','true');
      else continueLink.removeAttribute('aria-disabled');
    }
    if(note){
      if(!note.dataset.cleanMessage)note.dataset.cleanMessage=note.textContent.trim();
      var nextMessage=dirty
        ?'لديك تغييرات غير محفوظة. اضغط «تحديث السلة» قبل مراجعة تفاصيل الطلب.'
        :note.dataset.cleanMessage;
      if(note.textContent.trim()!==nextMessage)note.textContent=nextMessage;
      note.classList.toggle('is-warning',dirty);
    }
  }

  document.addEventListener('input',function(event){
    if(event.target.matches('[data-ix-qty-input]')){
      syncProduct(event.target.closest('[data-ix-product]'));
    }
    var cartForm=event.target.closest('.ix-cart-form');
    if(cartForm&&event.target.matches('input[name="updates[]"],textarea[name="note"],input[data-service]'))syncCartForm(cartForm);
  });

  document.addEventListener('click',function(event){
    var link=event.target.closest('.ix-product-whatsapp,[data-ix-product-contact]');
    var productRoot=link&&(link.closest('[data-ix-product]')||document.querySelector('[data-ix-product]'));
    if(link&&productRoot){
      syncProduct(productRoot);
      if(!link.hasAttribute('href')){
        event.preventDefault();
        productRoot.querySelector('[data-ix-qty-input]').reportValidity();
      }
    }

    var cartLink=event.target.closest('.ix-cart-whatsapp');
    var cartForm=cartLink&&cartLink.closest('.ix-cart-form');
    if(cartForm&&cartFormDirty(cartForm)){
      event.preventDefault();
      syncCartForm(cartForm);
      var update=cartForm.querySelector('[name="update"]');
      if(update)update.focus();
      return;
    }

    var menu=event.target.closest('[data-ix-menu]');
    if(menu){
      var header=menu.closest('.ix-shell,.ix-home-header');
      var nav=header&&header.querySelector('[data-ix-quicknav]');
      if(nav){
        var open=nav.classList.toggle('is-open');
        menu.setAttribute('aria-expanded',open?'true':'false');
      }
      return;
    }

    var favorite=event.target.closest('[data-ix-favorite]');
    if(favorite){
      var stored=readFavorites();
      if(!stored.ok){
        showGlobalFeedback(
          'تعذر حفظ المفضلة على هذا الجهاز. تحقق من إعدادات المتصفح وحاول مرة أخرى.',
          'error'
        );
        return;
      }
      var handle=favorite.getAttribute('data-ix-favorite');
      var items=stored.items.slice();
      var favoriteIndex=items.indexOf(handle);
      if(favoriteIndex>-1)items.splice(favoriteIndex,1);
      else items.push(handle);
      if(!writeFavorites(items)){
        showGlobalFeedback(
          'تعذر حفظ المفضلة على هذا الجهاز. تحقق من إعدادات المتصفح وحاول مرة أخرى.',
          'error'
        );
        return;
      }
      refreshFavorites(items);
      document.dispatchEvent(new CustomEvent('indexes:favorites-changed',{detail:{items:items}}));
      return;
    }

    var thumb=event.target.closest('[data-ix-gallery-thumb]');
    if(thumb){
      var gallery=thumb.closest('[data-ix-gallery]');
      if(!gallery)return;
      var galleryIndex=thumb.getAttribute('data-index');
      var slides=gallery.querySelectorAll('[data-ix-gallery-slide]');
      if(slides.length){
        slides.forEach(function(slide){
          var active=slide.getAttribute('data-index')===galleryIndex;
          slide.hidden=!active;
          slide.classList.toggle('is-active',active);
          if(!active){
            slide.querySelectorAll('video').forEach(function(video){
              try{video.pause()}catch(error){}
            });
            slide.querySelectorAll('iframe').forEach(function(frame){
              try{
                frame.contentWindow&&frame.contentWindow.postMessage(
                  '{"event":"command","func":"pauseVideo","args":""}',
                  '*'
                );
              }catch(error){}
            });
          }
        });
      }else{
        var main=gallery.querySelector('[data-ix-gallery-main]');
        if(main){
          main.src=thumb.getAttribute('data-src');
          main.alt=thumb.getAttribute('data-alt')||'';
        }
      }
      gallery.querySelectorAll('[data-ix-gallery-thumb]').forEach(function(el){
        el.classList.toggle('is-active',el===thumb);
      });
    }
  });

  document.addEventListener('change',function(event){
    var select=event.target.closest('[data-ix-variant-select]');
    if(!select)return;
    var option=select.options[select.selectedIndex];
    var root=select.closest('[data-ix-product]');
    var input=root&&root.querySelector('[data-ix-variant-id]');
    var price=root&&root.querySelector('[data-ix-product-price]');
    var add=root&&root.querySelector('[data-ix-add-product]');
    if(input)input.value=option.value;
    var qty=root&&root.querySelector('[data-ix-qty-input]');
    if(qty){qty.min=option.dataset.qtyMin||'1';qty.step=option.dataset.qtyStep||'1';if(option.dataset.qtyMax)qty.max=option.dataset.qtyMax;else qty.removeAttribute('max');if(!qty.checkValidity())qty.value=qty.min;}
    if(price&&option.dataset.price)price.textContent=option.dataset.price;
    syncProduct(root);
    if(add){
      var addForm=add.closest('form');
      var addState=addForm&&addStates.get(addForm);
      if(addState&&(addState.pending||addState.uncertain))return;
      var priced=Number(option.dataset.rawPrice)>0;
      var available=option.dataset.available==='true'&&priced;
      add.disabled=!available;
      // Suppress only the redundant inquiry placeholder; priced sold-out stays visible.
      add.hidden=!priced&&Boolean(root.querySelector('.ix-product-whatsapp[href^="https://wa.me/"]'));
      (add.querySelector('[data-ix-add-label]')||add).textContent=!priced?'استفسر عن السعر عبر واتساب':(available?'أضف إلى السلة':'غير متوفر');
    }
  });

  document.addEventListener('submit',function(event){
    var form=event.target;
    if(form.matches('.ix-product-actions,.ix-mini-cart-form')){
      enhanceAddSubmit(event,form);
      return;
    }
    if(form.matches('.ix-cart-form')){
      if(form.dataset.ixCartSubmitting==='true'){
        event.preventDefault();
        return;
      }
      form.dataset.ixCartSubmitting='true';
      form.setAttribute('aria-busy','true');
      var update=form.querySelector('[name="update"]');
      if(update){
        update.dataset.originalText=update.textContent;
        update.textContent='جارٍ تحديث السلة…';
        update.setAttribute('aria-disabled','true');
      }
      var note=form.querySelector('[data-ix-cart-update-note]');
      if(note){
        note.textContent='جارٍ تحديث السلة…';
        note.classList.remove('is-warning');
      }
    }
  });

  document.addEventListener('indexes:products-rendered',refreshFavorites);

  function initializeState(){
    refreshFavorites();
    document.querySelectorAll('[data-ix-product]').forEach(syncProduct);
    document.querySelectorAll('.ix-cart-form').forEach(syncCartForm);
  }

  window.addEventListener('pageshow',function(event){
    if(!event.persisted)return;
    document.querySelectorAll('.ix-product-actions,.ix-mini-cart-form').forEach(function(form){
      var state=addStates.get(form);
      if(!state&&!form.dataset.ixAddState)return;
      state=state||getAddState(form);
      var wasPending=state.pending||form.dataset.ixAddState==='pending';
      var wasUncertain=state.uncertain||form.dataset.ixAddState==='uncertain';
      state.generation++;
      if(state.controller){
        try{state.controller.abort()}catch(error){}
      }
      if(wasPending||wasUncertain){
        var endpoint=addEndpoint(form);
        markAddUncertain(form,state,endpoint?cartReviewUrl(endpoint):null);
        showAddFeedback(form,'warning','لم نتمكن من تأكيد نتيجة الإضافة بعد العودة إلى الصفحة. راجع السلة قبل المحاولة مرة أخرى.',endpoint?cartReviewUrl(endpoint):null);
      }else restoreAdd(form,state);
    });
    document.querySelectorAll('.ix-cart-form').forEach(function(form){
      delete form.dataset.ixCartSubmitting;
      form.removeAttribute('aria-busy');
      var update=form.querySelector('[name="update"]');
      if(update){
        update.removeAttribute('aria-disabled');
        if(update.dataset.originalText)update.textContent=update.dataset.originalText;
      }
      syncCartForm(form);
    });
    refreshFavorites();
    document.dispatchEvent(new CustomEvent('indexes:favorites-state-refresh'));
  });

  window.addEventListener('storage',function(event){
    if(event.key!==FAVORITES_KEY)return;
    refreshFavorites();
    document.dispatchEvent(new CustomEvent('indexes:favorites-state-refresh'));
  });

  window.IndexesFavoritesRuntime={read:readFavorites,refresh:refreshFavorites};
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initializeState,{once:true});
  }else{
    initializeState();
  }
})();

/* IX_EXT_V3 */
(function(){
  if(window.__ixWishlistBound)return;
  window.__ixWishlistBound=true;
  var renderGeneration=0;

  function readFavorites(){
    if(window.IndexesFavoritesRuntime)return window.IndexesFavoritesRuntime.read();
    try{
      var value=JSON.parse(localStorage.getItem('indexes_favorites_v1')||'[]');
      return Array.isArray(value)?{ok:true,items:value}:{ok:false,items:[]};
    }catch(error){
      return {ok:false,items:[]};
    }
  }

  function formatMoney(cents,currency){
    try{
      return new Intl.NumberFormat('ar-YE',{
        style:'currency',
        currency:currency||'YER',
        maximumFractionDigits:0
      }).format((Number(cents)||0)/100);
    }catch(error){
      return ((Number(cents)||0)/100).toFixed(0)+' '+(currency||'YER');
    }
  }

  function appendWishlistMessage(root,message){
    root.innerHTML='';
    var notice=document.createElement('p');
    notice.className='ix-empty-state';
    notice.setAttribute('role','status');
    notice.textContent=message;
    root.appendChild(notice);
  }

  function renderWishlist(){
    var root=document.querySelector('[data-ix-wishlist-list]');
    if(!root)return;
    var generation=++renderGeneration;
    var stored=readFavorites();
    if(!stored.ok){
      appendWishlistMessage(
        root,
        'تعذر الوصول إلى المفضلة المحفوظة على هذا الجهاز. تحقق من إعدادات المتصفح ثم أعد المحاولة.'
      );
      return;
    }
    var items=stored.items;
    if(!items.length){
      appendWishlistMessage(root,'لا توجد منتجات محفوظة في المفضلة على هذا الجهاز.');
      return;
    }
    var currency=root.getAttribute('data-currency')||'YER';
    var productRoot=window.Shopify&&Shopify.routes&&Shopify.routes.root
      ?Shopify.routes.root+'products/'
      :'/products/';
    Promise.all(items.map(function(handle){
      return fetch(productRoot+encodeURIComponent(handle)+'.js',{credentials:'same-origin'})
        .then(function(response){
          if(!response.ok)throw new Error('not found');
          return response.json();
        })
        .then(function(product){return {ok:true,handle:handle,product:product}})
        .catch(function(){return {ok:false,handle:handle}});
    })).then(function(results){
      if(generation!==renderGeneration)return;
      root.innerHTML='';
      var rendered=0;
      results.forEach(function(result){
        if(!result.ok)return;
        rendered++;
        var product=result.product;
        var titleText=product.title||result.handle;
        var card=document.createElement('article');
        card.className='ix-wishlist-card';
        var link=document.createElement('a');
        link.href=product.url||(productRoot+result.handle);
        var img=document.createElement('img');
        var featured=product.featured_image;
        img.src=typeof featured==='string'?featured:(featured&&featured.src?featured.src:'');
        img.alt=titleText||'منتج';
        img.loading='lazy';
        link.appendChild(img);
        var body=document.createElement('div');
        body.className='ix-wishlist-card__body';
        var title=document.createElement('a');
        title.href=link.href;
        title.textContent=titleText;
        var price=document.createElement('strong');
        price.textContent=Number(product.price)>0
          ?formatMoney(product.price,currency)
          :'استفسر عن السعر';
        var remove=document.createElement('button');
        remove.type='button';
        remove.setAttribute('data-ix-favorite',result.handle);
        remove.setAttribute('aria-pressed','true');
        remove.setAttribute('aria-label','إزالة '+titleText+' من المفضلة');
        remove.textContent='إزالة من المفضلة';
        body.appendChild(title);
        body.appendChild(price);
        body.appendChild(remove);
        card.appendChild(link);
        card.appendChild(body);
        root.appendChild(card);
      });
      if(!rendered)appendWishlistMessage(root,'تعذر تحميل المنتجات المحفوظة.');
    });
  }

  document.addEventListener('click',function(event){
    var minus=event.target.closest('[data-ix-qty-minus]');
    var plus=event.target.closest('[data-ix-qty-plus]');
    if(minus||plus){
      var root=(minus||plus).closest('.ix-quantity__control');
      var input=root&&root.querySelector('[data-ix-qty-input]');
      if(input){
        var value=Math.max(1,parseInt(input.value||'1',10)||1);
        var step=Number(input.step)||1,min=Number(input.min)||1,max=input.max?Number(input.max):Infinity;
        input.value=minus?Math.max(min,value-step):Math.min(max,value+step);
        input.dispatchEvent(new Event('input',{bubbles:true}));
      }
      return;
    }

    var sortButton=event.target.closest('[data-ix-sort]');
    if(sortButton){
      var form=sortButton.closest('form');
      var select=form&&form.querySelector('select[name="sort_by"]');
      if(select){
        select.value=sortButton.getAttribute('data-ix-sort');
        form.submit();
      }
      return;
    }

    var share=event.target.closest('[data-ix-share]');
    if(share){
      var url=share.getAttribute('data-ix-share')||location.href;
      if(navigator.share)navigator.share({url:url}).catch(function(){});
      else if(navigator.clipboard)navigator.clipboard.writeText(url).catch(function(){});
    }
  });

  document.addEventListener('indexes:favorites-changed',renderWishlist);
  document.addEventListener('indexes:favorites-state-refresh',renderWishlist);
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',renderWishlist,{once:true});
  }else{
    renderWishlist();
  }
})();

/* IX_DRAWER_SQUEEZE_FIX_V1 */
(function(){
  if(window.__ixDrawerSqueezeBound)return;
  window.__ixDrawerSqueezeBound=true;
  function clearDrawerSqueeze(){
    var wrapper=document.querySelector('.page-wrapper');
    if(!wrapper)return;
    if(wrapper.classList.contains('page-wrapper--drawer-open')){
      wrapper.classList.remove('page-wrapper--drawer-open');
    }
    wrapper.style.removeProperty('margin-right');
    wrapper.style.removeProperty('margin-left');
    wrapper.style.removeProperty('transform');
  }

  function watchDrawerSqueeze(){
    clearDrawerSqueeze();
    var wrapper=document.querySelector('.page-wrapper');
    if(!wrapper)return;
    var observer=new MutationObserver(function(){clearDrawerSqueeze()});
    observer.observe(wrapper,{attributes:true,attributeFilter:['class','style']});
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',watchDrawerSqueeze,{once:true});
  }else{
    watchDrawerSqueeze();
  }
})();

/* IX_MOTION_SYSTEM_V2 */
(function(){
  var root=document.documentElement;
  if(root.hasAttribute('data-ix-motion-bound'))return;
  root.setAttribute('data-ix-motion-bound','v2');

  var revealSelector=[
    '.ix-hero',
    '.ix-categories-section',
    '.ix-section__heading',
    '.ix-category-card',
    '.ix-home-category-item',
    '.ix-product-card',
    '.ix-promo-card',
    '.ix-trust-strip > span',
    '.ix-page__title',
    '.ix-collection-hero',
    '.ix-collection-card',
    '.ix-collection-tools',
    '.ix-gallery',
    '.ix-product-info',
    '.ix-cart-item',
    '.ix-cart-summary',
    '.ix-order-form',
    '.ix-offers-hero',
    '.ix-about-intro',
    '.ix-about-benefits article',
    '.ix-contact-card',
    '.ix-contact-form',
    '.ix-account-profile',
    '.ix-account-menu',
    '.ix-account-guest',
    '.ix-wishlist-card'
  ].join(',');
  var motion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduced=Boolean(motion&&motion.matches);
  var observer=null;
  var mutationObserver=null;
  var pending=new Set();
  var revealDisabled=false;
  var watchdog=0;

  function reveal(node){
    if(!node)return;
    node.classList.add('is-visible');
    pending.delete(node);
    if(observer){
      try{observer.unobserve(node)}catch(error){}
    }
  }

  function revealAll(disable){
    window.clearTimeout(watchdog);
    watchdog=0;
    pending.forEach(reveal);
    document.querySelectorAll('.ix-motion-item').forEach(reveal);
    if(disable){
      revealDisabled=true;
      if(observer){
        try{observer.disconnect()}catch(error){}
      }
      observer=null;
      if(mutationObserver)mutationObserver.disconnect();
      mutationObserver=null;
    }
  }

  function failOpen(){
    revealAll(true);
  }

  function armWatchdog(){
    if(watchdog||revealDisabled||!pending.size)return;
    watchdog=window.setTimeout(failOpen,2500);
  }

  function createObserver(){
    // Product content stays immediately visible on narrow screens.
    if(reduced||(window.matchMedia&&window.matchMedia('(max-width: 749px)').matches)||!('IntersectionObserver' in window)){
      revealDisabled=true;
      return;
    }
    try{
      observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting)reveal(entry.target);
        });
        if(!pending.size){
          window.clearTimeout(watchdog);
          watchdog=0;
        }
      },{threshold:0,rootMargin:'0px 0px -5% 0px'});
    }catch(error){
      observer=null;
      revealDisabled=true;
    }
  }

  function collect(scope){
    var nodes=[];
    if(scope&&scope.nodeType===1&&scope.matches&&scope.matches(revealSelector))nodes.push(scope);
    if(scope&&scope.querySelectorAll){
      scope.querySelectorAll(revealSelector).forEach(function(node){nodes.push(node)});
    }
    return nodes;
  }

  function bindReveal(scope){
    if(revealDisabled)return;
    collect(scope).forEach(function(node,index){
      if(node.dataset.ixMotionBound==='2')return;
      node.dataset.ixMotionBound='2';
      node.style.setProperty('--ix-motion-delay',Math.min(index%6,5)*55+'ms');
      if(revealDisabled||reduced||!observer){
        node.classList.add('is-visible');
        return;
      }
      node.classList.add('ix-motion-item');
      pending.add(node);
      try{
        observer.observe(node);
      }catch(error){
        failOpen();
      }
    });
    armWatchdog();
  }

  var headers=[];
  var headerScrolled=null;
  function updateHeader(refresh){
    var scrolled=(window.scrollY||document.documentElement.scrollTop||0)>10;
    var stale=!headers.length||headers.some(function(header){return !header.isConnected});
    if(!refresh&&!stale&&scrolled===headerScrolled)return;
    if(refresh||stale)headers=Array.from(document.querySelectorAll('.ix-shell,.ix-home-header'));
    headerScrolled=scrolled;
    headers.forEach(function(header){
      header.classList.toggle('is-scrolled',scrolled);
      header.classList.toggle('ix-is-scrolled',scrolled);
    });
  }

  function initMotion(){
    if(reduced)root.classList.add('ix-motion-reduced');
    else root.classList.add('ix-motion-ready');
    createObserver();
    bindReveal(document);
    if(document.body&&!revealDisabled){
      mutationObserver=new MutationObserver(function(records){
        records.forEach(function(record){
          record.addedNodes.forEach(function(node){
            if(node.nodeType===1)bindReveal(node);
          });
        });
      });
      mutationObserver.observe(document.body,{childList:true,subtree:true});
    }
    updateHeader();
    // Native :active feedback needs no click listener or forced layout.
  }

  var ticking=false;
  window.addEventListener('scroll',function(){
    if(ticking)return;
    ticking=true;
    window.requestAnimationFrame(function(){
      updateHeader();
      ticking=false;
    });
  },{passive:true});

  document.addEventListener('visibilitychange',function(){
    if(document.body)document.body.classList.toggle('ix-motion-paused',document.hidden);
  });

  document.addEventListener('shopify:section:load',function(event){
    bindReveal(event.target||document);
    updateHeader(true);
  });

  window.addEventListener('pageshow',function(event){
    if(event.persisted)failOpen();
  });

  function onMotionChange(event){
    reduced=event.matches;
    if(reduced){
      root.classList.add('ix-motion-reduced');
      failOpen();
    }else{
      root.classList.remove('ix-motion-reduced');
      root.classList.add('ix-motion-ready');
    }
  }
  if(motion){
    if(motion.addEventListener)motion.addEventListener('change',onMotionChange);
    else if(motion.addListener)motion.addListener(onMotionChange);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initMotion,{once:true});
  }else{
    initMotion();
  }
  window.addEventListener('load',function(){bindReveal(document)},{once:true});
})();
window.IX_MOTION_SYSTEM_V2=true;



/* IX_PRODUCT_MEDIA_FALLBACK_V10: neutral existing Shopify artwork on actual image failure. */
(function(){
  if(window.__ixProductMediaFallback)return;
  window.__ixProductMediaFallback=true;
  function failed(image){
    if(!image||image.tagName!=='IMG'||image.dataset.ixMediaFailed||!image.isConnected)return;
    var scope=image.closest('.ix-product-card__media,.ix-gallery');
    if(!scope)return;
    var template=scope.querySelector('template[data-ix-media-fallback]');
    var svg=template&&template.content.querySelector('svg');
    if(!svg)return;
    var originalAlt=image.getAttribute('alt')||'';
    image.dataset.ixMediaFailed='true';
    image.dataset.ixOriginalSrc=image.getAttribute('src')||'';
    image.dataset.ixOriginalSrcset=image.getAttribute('srcset')||'';
    image.dataset.ixOriginalAlt=originalAlt;
    image.removeAttribute('srcset');
    image.alt='تعذر تحميل صورة المنتج'+(originalAlt?' — '+originalAlt:'');
    image.src='data:image/svg+xml;charset=utf-8,'+encodeURIComponent(svg.outerHTML);
  }
  function scan(node){
    if(!node||node.nodeType!==1)return;
    function check(image){if(image.complete&&!image.naturalWidth&&image.getAttribute('src'))failed(image)}
    if(node.tagName==='IMG')check(node);
    node.querySelectorAll('img').forEach(check);
  }
  document.addEventListener('error',function(event){failed(event.target)},true);
  function start(){
    scan(document.body);
    new MutationObserver(function(records){records.forEach(function(record){record.addedNodes.forEach(scan)})}).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

